import React from 'react';
import { Helmet } from "react-helmet";
import Header from "../../components/Header";
import ForgotPasswords from "../../components/ForgotPassword";
import ChangePassword from "../../components/ChangePassword";
import Footer from "../../components/Footer";
import { useParams  } from "react-router-dom";

import './ForgotPassword.styles.css';

const ForgotPassword = () => {
	return (
		<div>
			<Helmet>
				<title>Forgot Password</title>
			</Helmet>
			<Header />
			<ForgotPasswords />
			<Footer />
		</div>
	);
};

export default ForgotPassword;